import React from "react";
import { ChevronRight } from "lucide-react";

// Wraps the part of `text` that matches `query` in a highlight.
export const Highlight = ({ text = "", query = "" }) => {
  const q = query.trim();
  if (!q) return text;
  const i = text.toLowerCase().indexOf(q.toLowerCase());
  if (i < 0) return text;
  return (
    <>
      {text.slice(0, i)}
      <mark className="bg-[#fff3c4] text-inherit rounded-sm px-0.5">
        {text.slice(i, i + q.length)}
      </mark>
      {text.slice(i + q.length)}
    </>
  );
};

// One setting on the Settings page: icon tile, title, short description and
// an arrow that appears on hover/focus. A real <button>, so it is reachable
// with Tab and opens with Enter/Space.
const SettingsItemContainer = ({
  setting,
  index,
  handleItemClick = () => {},
  query = "",
}) => {
  return (
    <button
      type="button"
      key={index}
      onClick={() => handleItemClick(index, setting)}
      className="group w-full h-full text-left flex items-start gap-4 p-4 rounded-xl border border-[var(--light-border-color)] bg-white transition-all duration-200 hover:border-[var(--primary)] hover:shadow-[0_8px_24px_-12px_rgba(39,125,254,0.45)] hover:-translate-y-0.5 focus:outline-none focus-visible:border-[var(--primary)] focus-visible:ring-2 focus-visible:ring-[var(--row-selection-color)]"
    >
      <span className="shrink-0 w-10 h-10 rounded-lg bg-primary flex items-center justify-center [&_svg]:max-w-[22px] [&_svg]:max-h-[22px]">
        {setting.icon}
      </span>
      <span className="flex-1 min-w-0">
        <span className="block text-sm fw_600 text-[var(--heading-color)] group-hover:text-[var(--primary)]">
          <Highlight text={setting.title} query={query} />
        </span>
        <span className="block mt-0.5 text-xs leading-5 text-[var(--description-color)] line-clamp-2">
          <Highlight text={setting.desc} query={query} />
        </span>
      </span>
      <ChevronRight
        size={18}
        className="shrink-0 mt-2.5 text-[var(--description-color)] opacity-0 -translate-x-1 transition-all duration-200 group-hover:opacity-100 group-hover:translate-x-0 group-hover:text-[var(--primary)] group-focus-visible:opacity-100"
      />
    </button>
  );
};

export default SettingsItemContainer;
